import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Folder } from 'lucide-react';
import axios from 'axios';
import ModernCard from '../components/ModernCard';
import { API_ENDPOINTS } from '../config/api';
import { buildUnitUrl } from '../utils/urlHelpers';
import './ModernHomePage.css';

const ModernHomePage = () => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUnits();
  }, []);

  const fetchUnits = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_ENDPOINTS.UNITS);
      setUnits(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching units:', err);
      setError('Failed to load units. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="modern-home-page">
        <div className="page-container">
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p>Loading units...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modern-home-page">
        <div className="page-container">
          <div className="error-state">
            <h3>Error Loading Units</h3>
            <p>{error}</p>
            <button className="retry-button" onClick={fetchUnits}>
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modern-home-page">
      <div className="page-container">
        {/* Header Section */}
        <header className="page-header">
          <h1 className="page-title">Semester 2 Learning Resources</h1>
          <p className="page-subtitle">Computer Science Year 1 Study Materials</p>
        </header>

        {/* Unit Cards */}
        <div className="cards-grid">
          {units.map((unit) => (
            <Link key={unit} to={buildUnitUrl(unit)} className="card-link">
              <ModernCard
                icon={Folder}
                title={unit}
                description="View learning materials and resources"
                buttonText="Open Unit"
                variant="unit"
                className="unit-card"
              />
            </Link>
          ))}
        </div>

        {units.length === 0 && (
          <div className="empty-state">
            <Folder size={48} />
            <h3>No Units Found</h3>
            <p>No units are available for this semester.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModernHomePage;
